// export const cookie_domain_url = "localhost"  // localhost
// export const cookie_domain_url = ".corp.cnplinc.com" // staging domain
export const cookie_domain_url = ".p-up.tech"  //  prod domain
// export const corporate_pay_as_you_go_cat_id = 3;
export const logoutURL =
  "http://localhost/PUP-1/api/api/v11/atom/auth/logout?key=d42121c70dda5edfgd1df6633fdb36c0&platform=D_P";
export const loginURL =
  "http://localhost/PUP-1/api/api/v11/atom/auth/login?key=d42121c70dda5edfgd1df6633fdb36c0&platform=D_P";
export const refreshTokenURL =
  "http://localhost/PUP-1/api/api/v11/atom/auth/refreshTokenV2?key=d42121c70dda5edfgd1df6633fdb36c0&platform=D_P";
export const userInfoUrl = 
  "http://localhost/PUP-1/api/api/v11/atom/user/getDetails?key=d42121c70dda5edfgd1df6633fdb36c0&platform=D_P&partner_id=1";
export const getPackagesUrl = 
   "http://localhost/PUP-1/api/api/v11/atom/Packages/getPackages?key=d42121c70dda5edfgd1df6633fdb36c0&platform=D_P"; 
   export const getPackagesInfoUrl = 
   "http://localhost/PUP-1/api/api/v11/atom/Packages/getPackageInfo?key=d42121c70dda5edfgd1df6633fdb36c0&platform=D_P"; 
   export const getAccountTypesUrl = 
   "http://localhost/PUP-1/api/api/v11/atom/Packages/getPackageAccountType?key=d42121c70dda5edfgd1df6633fdb36c0&platform=D_P"
